"use client";

import { BreadcrumbList, SearchResultsPage, WebSite, WithContext } from "schema-dts";
import { getDescription, getTitle } from "utils/helper";
import { isDev } from "utils/ssr";
import { createSearchURL, makeBaseUrl, makeCDNUrl } from "utils/url";
const VacationRentalsJsonSchema = ({
  searchName
}: {
  searchName: string;
}) => {
  const title = getTitle(searchName);
  const description = getDescription(searchName);
  const canonical = makeBaseUrl(`/vacation-rentals/${createSearchURL(searchName || "")}`);
  if (isDev()) return null;
  return <>
      <script type='application/ld+json' dangerouslySetInnerHTML={{
      __html: JSON.stringify(({
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: [{
          "@type": "ListItem",
          position: 1,
          name: "Home page",
          item: makeBaseUrl("")
        }, {
          "@type": "ListItem",
          position: 2,
          name: "Vacation-rentals",
          item: canonical
        }]
      } satisfies WithContext<BreadcrumbList>))
    }} />

      <script type='application/ld+json' dangerouslySetInnerHTML={{
      __html: JSON.stringify(({
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: "Whimstay",
        url: canonical,
        potentialAction: {
          "@type": "SearchAction",
          target: makeBaseUrl("/vacation-rentals/{search_term_string}"),
          query: "required name=search_term_string"
        }
      } satisfies WithContext<WebSite>))
    }} />
      <script type='application/ld+json' dangerouslySetInnerHTML={{
      __html: JSON.stringify(({
        "@context": "https://schema.org",
        "@type": "SearchResultsPage",
        name: title,
        audience: "Travelers, Families, Friends, Couples",
        description: description,
        url: canonical,
        publisher: {
          "@type": "Organization",
          name: "Whimstay",
          logo: {
            "@type": "ImageObject",
            url: makeBaseUrl("/assets/images/travel-agent/logo.png")
          },
          image: makeBaseUrl("/assets/images/travel-agent/og/signature-stay.jpg"),
          address: {
            "@type": "PostalAddress",
            streetAddress: "580 California St",
            addressLocality: "Suites 1200 & 1600",
            addressRegion: "San Francisco, CA",
            postalCode: "94104-1000",
            addressCountry: "USA"
          },
          telephone: "+1(415)-799-1128"
        },
        potentialAction: {
          "@type": "RentAction",
          object: {
            "@type": "Accommodation",
            name: `${searchName || ""} Vacation Rentals`
          },
          location: {
            "@type": "Place",
            name: `${searchName?.split(",")[0] || ""}`
          }
        }
      } satisfies WithContext<SearchResultsPage>))
    }} />
    </>;
};
export default VacationRentalsJsonSchema;